import { MovieOpenCheckOutlineIcon } from './MovieOpenCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 3CA87DEB-5A40-4DAF-960B-2AA9A4385F1D
 * name movie-open-check-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-check-outline.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenCheckOutlineIcon = MovieOpenCheckOutlineIcon;
export default ClapperboardOpenCheckOutlineIcon